module.exports = __webpack_public_path__ + "components/MapControl/svg/Toaleta publiczna.svg?531ca2a3";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Toaleta publiczna.svg
// module id = 2041
// module chunks = 0